import React from "react";
import { useTranslation } from "react-i18next";
import "./StatusDisplay.css";

export const StatusDisplay = ({ status }) => {
  const { t } = useTranslation();
  if (!status) {
    return null;
  }

  const isActive = status === "states.active" ? true : false;

  return (
    <div
      className="StatusDisplay"
      style={{
        backgroundColor: isActive ? "#53A682" : "#D69D23",
      }}
    >
      {t(status)}
    </div>
  );
};
